import { render, staticRenderFns } from "./c-master-table.vue?vue&type=template&id=5ab2f7ef&scoped=true"
import script from "./c-master-table.vue?vue&type=script&lang=js"
export * from "./c-master-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2f7ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab2f7ef')) {
      api.createRecord('5ab2f7ef', component.options)
    } else {
      api.reload('5ab2f7ef', component.options)
    }
    module.hot.accept("./c-master-table.vue?vue&type=template&id=5ab2f7ef&scoped=true", function () {
      api.rerender('5ab2f7ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/master/c-master-table.vue"
export default component.exports